export default __webpack_public_path__ + "images/7101e85453a510337338e3546ccacf4b.png";